import React, { Component } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SuccessfulReg from '../components/SuccessfulReg';
import { getUserEmail } from '../service/UserService';

class SuccessfulRegistration extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      userData: null,
      userEmail: '',
      showToast: false,
      toastMsg: ''
     }
  }

  componentDidMount(){
    this.setState({userEmail: getUserEmail()});
  }

  render() { 
    return ( 
      <div style={{paddingBottom:30}}>
        <div className="row" style={{width:'100%', margin:'auto'}}>
            <SuccessfulReg history={this.props.history} email={this.state.userEmail}></SuccessfulReg>                    
        </div>
        <ToastContainer />
      </div> 
    );
  }
}
 
export default SuccessfulRegistration;